export function appendIdToItems(items) {
  return items.map((item, index) => ({
    id: index + 1,
    name: item.nome,
  }));
}
